import { useTranslation } from "react-i18next";
import "./request_new_access_for_others.css";
import { useEffect, useRef, useState } from "react";
import { Breadcrumb,Button, DataTable } from "pepsico-ds";
import { useLocation, useNavigate } from "react-router-dom";
// import { ROUTE_PATHS } from "../../utils/constant";
import axios from "axios";
import { useLoading } from "../../loader.jsx";

const RequestNewAccessForOthers = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { REACT_APP_API_ENDPOINT } = process.env;
    const selectedGPID = useRef('');
    const { state } = useLocation();
    const [users, setUsers] = useState([]);  
    const [selectedRow, setSelectedRow] = useState(null);
    const { showLoader, hideLoader } = useLoading();
    const [loading, setLoading] = useState(false);
    const [columns, setColumns] = useState([
            { columnKey: "uid", header: `${t('RequestNewAccessForOthers.gpid')}`, size: 200,  cellData: (ctx) => {
                return <>
                    <input
                        type="radio"
                        name="row-selection"
                        value={ctx.row.original.uid}
                        checked={!!(selectedGPID.current && selectedGPID.current === ctx.row.original.uid)}
                        onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
                        style={{ textAlign: 'center', marginRight: '10px' }}
                    />
                        {ctx.row.original.uid}
                    </>
            }},
            { columnKey: "pepDisplayedFirstName", header: `${t('RequestNewAccessForOthers.first_name')}`, size: 200, showColumnVisibility: true },
            { columnKey: "pepDisplayedLastName", header: `${t('RequestNewAccessForOthers.last_name')}`, size: 200 },
            { columnKey: "mail", header: `${t('RequestNewAccessForOthers.email')}`, size: 200 },
            { columnKey: "pepUserType", header: `${t('RequestNewAccessForOthers.associate_type')}`, size: 200 },
            { columnKey: "pepDivisionName", header: `${t('RequestNewAccessForOthers.division')}`, size: 200 },
            { columnKey: "pepsubdivision", header: `${t('RequestNewAccessForOthers.sub_division')}`, size: 200 },
            { columnKey: "pepLocName", header: `${t('RequestNewAccessForOthers.location')}`, size: 200 },
            { columnKey: "pepUserStatus", header: `${t('RequestNewAccessForOthers.status')}`, size: 200 },
            { columnKey: "pepRegistered", header: `${t('RequestNewAccessForOthers.registered')}`, size: 200 },
        ]);

    useEffect(()=>{
        showLoader();
        axios.post(REACT_APP_API_ENDPOINT + "user/searchuser", {
            [state.type === `${t('RequestNewAccessForOthers.gpid')}` ? 'gpid' : state.type === `${t('updateProfile.firstName')}` ? 'firstName' : state.type === `${t('updateProfile.lastName')}` ? 'lastName' : 'email'] : state.value
        }).then((response)=>{
            setLoading(false);
            hideLoader();
            setUsers(Object.values(response?.data?.userData));
        }).catch((error)=>{
            setLoading(false);
            hideLoader();
            console.log('error', error);
        })
    },[state.type, state.value]);

    useEffect(()=>{
        setColumns([
            { columnKey: "uid", header: `${t('RequestNewAccessForOthers.gpid')}`, size: 200,  cellData: (ctx) => {
                return <>
                    <input
                        type="radio"
                        name="row-selection"
                        value={ctx.row.original.uid}
                        checked={!!(selectedGPID.current && selectedGPID.current === ctx.row.original.uid)}
                        onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
                        style={{ textAlign: 'center', marginRight: '10px' }}
                    />
                        {ctx.row.original.uid}
                    </>
            }},
            { columnKey: "givenName", header: `${t('RequestNewAccessForOthers.first_name')}`, size: 200, showColumnVisibility: true },
            { columnKey: "sn", header: `${t('RequestNewAccessForOthers.last_name')}`, minSize: 200, maxSize: 250},
            { columnKey: "mail", header: `${t('RequestNewAccessForOthers.email')}`, size: 200,  minSize: 200, maxSize: 250 },
            { columnKey: "pepUserType", header: `${t('RequestNewAccessForOthers.associate_type')}`, size: 200 },
            { columnKey: "pepDivisionName", header: `${t('RequestNewAccessForOthers.division')}`, size: 200 },
            { columnKey: "pepsubdivision", header: `${t('RequestNewAccessForOthers.sub_division')}`, size: 200 },
            { columnKey: "pepLocName", header: `${t('RequestNewAccessForOthers.location')}`, size: 200 },
            { columnKey: "pepUserStatus", header: `${t('RequestNewAccessForOthers.status')}`, size: 200 },
            { columnKey: "pepRegistered", header: `${t('RequestNewAccessForOthers.registered')}`, size: 200 },
        ]);
    },[selectedRow]);

    const onClickSelect = () => {
        let statePayload = {};
        console.log('111111111111',selectedRow);
        
        if (selectedRow) {
          statePayload = { type: `${t('RequestNewAccessForOthers.gpid')}`, value: selectedRow.uid };
          navigate("/request-access", { state: statePayload });
        }
        else{
        //   statePayload = { type: requestOthersSelectedValue, value: requestOthersSelectedText };
        //   navigate("/request-new-access-others", { state: statePayload });
        }
    }

    const onClickCancel = () => {
        navigate('/myidmPortal')
    } 

    const onRowSelectionChange = (e, user) => {
        e.stopPropagation();
        setSelectedRow(user);
        selectedGPID.current = user.uid;
    };

    return (
        <div className="request-new-access-for-others h-100">
            <Breadcrumb
                homeIcon={{
                    icon: "home",
                    onClick:()=>{
                    navigate("/home")
                    }
                }}
                breadcrumbs={[
                {
                    label: "Home",
                },
                {
                    label: <div onClick={()=>{
                        navigate("/myidm")
                    }}>myidM</div>
                },
                {
                    label: <div onClick={()=>{
                        navigate("/request-new-access-others")
                    }}>Request Access for Other Associate</div>
                },
                ]}
                className=""
                onClick={function Xs() {}}
                useAnchor
                style={{ marginBottom: "1rem !important" }}
            />
            <p className="request-new-access-for-others-main-header">{t('RequestNewAccessForOthers.request_new_access_main_header')}</p>
            {loading ? (
                <div className="loading-container">
                    <span className="search-subtitle">
                        {t('RequestNewAccessForOthers.loading_text')}
                    </span>
                </div>
            ) :
            <div className="request-new-access-for-others-main-content h-100 m-0">
                <div className="search-result mt-md-3">{`${users.length} ${t('RequestNewAccessForOthers.search_results_for')} ${state.type} “${state.value}”`}</div>
                {users.length > 0 ? <DataTable
                    className="datatable"
                    columns={columns}
                    enableSorting={true}
                    data={users}
                    pageIndex={0}
                    pageSize={10}
                    searchPlaceholder={t("RequestGPIDForNonEmployee.search_placeholder")}
                    selection="single"
                    size="large"
                    showTitle={false}
                    showSearchOption={true}
                    showTableHeader={true}
                    showColumnFilters={false}
                    showDescription={false}
                    tableDescription=""
                    tableHeader=""
                /> : null}
                <hr className="request-new-access-for-others-hr"/>
                {users.length > 0 ? <div className="request-gpid-content-footer pr-3 row" style={{justifyContent:'flex-end'}}>
                    <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0 px-md-0 justify-content-center">
                        {/* <button className="search-user-cancel-button mr-md-2 my-0 px-3"  onClick={onClickCancel}>
                            {t("RequestGPIDForNonEmployee.cancel_btn_label")}
                        </button> */}
                        <Button
                        className="search-user-cancel-button mr-md-2 my-0 px-3"
                        type="button"
                        size="medium"
                        text={t("RequestGPIDForNonEmployee.cancel_btn_label")}
                        variant="tertiary"
                        onClick={onClickCancel}
                        />
                    </div>
                    <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0">
                        {/* <button className="search-user-select-button request-button my-0 px-3"  onClick={onClickSelect}>
                            {t("RequestGPIDForNonEmployee.select_btn_label")}
                        </button> */}
                        <Button
                        className="search-user-select-button request-button my-0 px-3 justify-content-center"
                        type="button"
                        size="medium"
                        text={t("RequestGPIDForNonEmployee.select_btn_label")}
                        variant="primary"
                        onClick={onClickSelect}
                        />
                    </div>
                </div> : null}
            </div>
        }
        </div>
    );

}


export default RequestNewAccessForOthers;